import { type Country, type PublicCountryConfig } from './types.js';
import { uzPublic } from './uz.public.js';
import { kzPublic } from './kz.public.js';
import { kgPublic } from './kg.public.js';

// The web-safe registry. The browser imports ONLY this (via `apps/web/country.ts`)
// — it references `uz.public.ts`, never the full `uzConfig` (uz.ts), so the
// classifier / companyId / sourceKeys and their Node-adjacent code never enter
// the browser bundle. `Record<Country, …>` totality: adding a country to
// COUNTRIES fails to compile here until a matching public entry exists.
export const publicCountryConfigs: Record<Country, PublicCountryConfig> = {
  uz: uzPublic,
  kz: kzPublic,
  kg: kgPublic,
};
